import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

import ManageSearchIcon from "@mui/icons-material/ManageSearchOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExploreOutlined";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjectsOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUserOutlined";

import DesktopSteps from "./DesktopSteps";
import MobileSteps from "./MobileSteps";

const title = "How We Work";
const description =
  "A structured, collaborative approach that ensures seamless execution and continuous improvement at every stage of your DAM journey.";

const stepsData = [
  {
    number: "01",
    icon: ManageSearchIcon,
    title: "Discover Needs",
    description: "Work closely with your team to define the right strategy and approach.",
  },
  {
    number: "02",
    icon: TravelExploreIcon,
    title: "Understand As-Is",
    description: "Analyze your current DAM landscape, challenges, and business goals.",
  },
  {
    number: "03",
    icon: EmojiObjectsIcon,
    title: "Recommend Solution",
    description:
      "Review DAM solutions and make best-fit recommendations that satisfy business needs.",
  },
  {
    number: "04",
    icon: SettingsIcon,
    title: "Implement Solution",
    description: "Implement DAM solutions with seamless integration and precision.",
  },
  {
    number: "05",
    icon: VerifiedUserIcon,
    title: "Drive Governance",
    description: "Continuously improve workflows, performance, and user experience.",
  },
];

export default function HowWork() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        backgroundColor: "#FFF",
        px: {
          xs: "16px",
          sm: "24px",
          md: "84px",
        },
        py: {
          xs: "30px",
          sm: "48px",
          md: "48px",
        },
        // maxWidth: 1272,
        // mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "24px",
              sm: "32px",
              md: "40px",
            },
            fontWeight: 700,
            color: "#2A2177",
            mb: 1.25,
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: "14px",
              sm: "16px",
              md: "18px",
            },
            fontWeight: 400,
            color: "#666666",
            lineHeight: 1.7,
            // mb: 5,
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* Steps and its Data */}
      <Box>
        {isDesktop ? (
          <DesktopSteps stepsData={stepsData} />
        ) : (
          <MobileSteps stepsData={stepsData} />
        )}
      </Box>
    </Box>
  );
}
